import {PromoCode, PromoType} from '@domain/model/PromoCode/PromoCode';

const GetMultiBoxPromoCode =
  () =>
  (autoApplicablePromo: string): PromoCode | null => {
    return autoApplicablePromo ? {value: autoApplicablePromo, type: PromoType.MULTIBOX} : null;
  };

export {GetMultiBoxPromoCode};
